import React from 'react';
import Blanket from '@atlaskit/blanket';
import Placeholder from '@atlassian/jira-placeholder';
import { useSwitchModals } from '@atlassian/jira-switch-modals-controller';
import { lazy } from '@atlassian/react-loosely-lazy';
import type DeleteModal from './main';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncDeleteGadgetModal = lazy<typeof DeleteModal>(
	() => import(/* webpackChunkName: "async-dashboard-delete-gadget-modal" */ './main'),
);

export const DeleteGadgetModal = ({
	id,
	onDeleteGadget,
	gadgetName,
	onClose,
}: {
	id: string;
	gadgetName: string;
	onDeleteGadget: () => Promise<void>;
	onClose: () => void;
}) => {
	const [isOpen, { off: close }] = useSwitchModals(id);
	return isOpen ? (
		<Placeholder name="delete-gadget-modal" fallback={<Blanket />}>
			<AsyncDeleteGadgetModal
				gadgetName={gadgetName}
				onClose={() => {
					close();
					onClose?.();
				}}
				onDeleteGadget={onDeleteGadget}
			/>
		</Placeholder>
	) : null;
};
